import * as React from "react";
import { useCallback, useRef } from "react";
import Box from "../../../parts/Box";
import classNames from "classnames";
import scrollToSection from "./scrollToSection";
import PrintButton from "./print-button";
import { useResultsContext } from "../context/results-context";
import { spinnerIcon } from "../../../Messages";

function JobContentsComponent() {

  const {
    selectSection,
    availableSections: sections,
    selectedSections,
  } = useResultsContext();

  const boxRef = useRef<HTMLDivElement>(null);
  
  const handleChange = useCallback((ev) => {
    selectSection(ev.target.dataset.id, ev.target.checked);
  }, [selectSection]);

  const handleClick = useCallback((ev) => {
    // select if not selected
    if (ev.target.dataset.selected === "false") {
      selectSection(ev.target.dataset.id, true);
    }
    // scroll
    scrollToSection(ev.target.dataset.id);
  }, [selectSection])

  return (
    <Box title="Contents" className="ll-fixed" boxRef={boxRef}>
      <div className="ll-contents-export">
        <PrintButton />
      </div>
      <div className="ll-contents-list">
        {sections.map(section => {
          const selected = selectedSections[section.id] ?? false;
          return (
            <p key={section.id} className={classNames({"ll-screen": !selected || section.screenOnly})}>
              <input
                type="checkbox"
                checked={selected}
                disabled={section.disabled || section.loading}
                data-id={section.id}
                onChange={handleChange}
              />
              <span
                className="ll-contents-link"
                onClick={handleClick}
                data-id={section.id}
                data-selected={selected}
                title={`Select and navigate to ${section.name}`}
              >
              {section.name}
            </span>
              {section.loading ? spinnerIcon : null}
            </p>
          )
        })}
      </div>
    </Box>
  )
}

export default JobContentsComponent;
